(function () {
  'use strict';

  var SIGNS = [
    { key: 'aries',       name: 'Aries',       glyph: '\u2648' },
    { key: 'taurus',      name: 'Taurus',      glyph: '\u2649' },
    { key: 'gemini',      name: 'Gemini',      glyph: '\u264A' },
    { key: 'cancer',      name: 'Cancer',      glyph: '\u264B' },
    { key: 'leo',         name: 'Leo',         glyph: '\u264C' },
    { key: 'virgo',       name: 'Virgo',       glyph: '\u264D' },
    { key: 'libra',       name: 'Libra',       glyph: '\u264E' },
    { key: 'scorpio',     name: 'Scorpio',     glyph: '\u264F' },
    { key: 'sagittarius', name: 'Sagittarius', glyph: '\u2650' },
    { key: 'capricorn',   name: 'Capricorn',   glyph: '\u2651' },
    { key: 'aquarius',    name: 'Aquarius',    glyph: '\u2652' },
    { key: 'pisces',      name: 'Pisces',      glyph: '\u2653' }
  ];

  var DEG = Math.PI / 180;
 
  /* ---------- Astronomy helpers ---------- */
  function signFromLongitude(lonDeg) {
    var norm = ((lonDeg % 360) + 360) % 360;
    var idx = Math.floor(norm / 30);
    return { sign: SIGNS[idx], degree: norm - idx * 30 };
  }

  function meanObliquityDeg(astroTime) {
    var T = astroTime.tt / 36525;
    return 23.43929111 - (46.8150 / 3600) * T;
  }

  function sunMoonLongitudes(utcDate) {
    var A = window.Astronomy;
    var t = A.MakeTime(utcDate);
    var moonSph = A.EclipticGeoMoon(t);
    var sunEQJ = A.GeoVector(A.Body.Sun, t, true);
    var rot = A.Rotation_EQJ_ECT(t);
    var sunECT = A.RotateVector(rot, sunEQJ);
    var sunLon = (Math.atan2(sunECT.y, sunECT.x) * 180 / Math.PI + 360) % 360;
    return { sun: sunLon, moon: moonSph.lon, time: t };
  }

  function localSiderealTimeDeg(astroTime, lonEastDeg) {
    return ((window.Astronomy.SiderealTime(astroTime) * 15 + lonEastDeg) % 360 + 360) % 360;
  }

  function computeAscendantDeg(lstDeg, obliquityDeg, latDeg) {
    var H = lstDeg * DEG, eps = obliquityDeg * DEG, phi = latDeg * DEG;
    var asc = Math.atan2(-Math.cos(H), Math.sin(eps) * Math.tan(phi) + Math.cos(eps) * Math.sin(H)) / DEG;
    return (asc + 360) % 360;
  }

  /* ---------- Services ---------- */
  function nominatimSearch(q) {
    return fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(q)).then(function (r) { return r.json(); });
  }

  function fetchTimezone(lat, lng) {
    return fetch('https://timeapi.io/api/timezone/coordinate?latitude=' + lat + '&longitude=' + lng).then(function (r) { return r.json(); }).then(function (j) { return j.timeZone; }).catch(function () { return 'UTC'; });
  }

  function debounce(fn, ms) {
    var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }

  // Converts a "naive" local (Y, M, D, h, m) that is assumed to be in IANA
  // timezone `tz` into a real UTC Date. Works for any date, including
  // historical DST transitions, by asking Intl for the wall-clock time that
  // the tz observes at our first guess, then correcting by the delta.
  function zonedToUtc(year, month, day, hour, minute, tz) {
    var guess = Date.UTC(year, month - 1, day, hour, minute, 0);
    try {
      var dtf = new Intl.DateTimeFormat('en-US', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      var parts = dtf.formatToParts(new Date(guess));
      var o = {};
      parts.forEach(function (p) { if (p.type !== 'literal') o[p.type] = p.value; });
      var asIfUtc = Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute, +o.second);
      var offsetMs = asIfUtc - guess;
      return new Date(guess - offsetMs);
    } catch (e) {
      return new Date(guess);
    }
  }

  /* ---------- Heading reveal (GSAP, word-by-word from below — Codepen-style) ---------- */
  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function splitHeadingIntoWordSpans(el) {
    if (el.querySelector('.quiz-signs__word-inner')) return;
    var raw = (el.textContent || '').trim();
    if (!raw) return;
    el.setAttribute('aria-label', raw);
    var words = raw.split(/\s+/);
    el.innerHTML = words.map(function (w) {
      return '<span class="quiz-signs__word-clip" aria-hidden="true"><span class="quiz-signs__word-inner">' + escHtml(w) + '</span></span>';
    }).join('');
  }

  function playStep1Heading(el) {
    if (!el || !window.gsap || prefersReducedMotion()) return;
    var gs = window.gsap;
    splitHeadingIntoWordSpans(el);
    var inners = el.querySelectorAll('.quiz-signs__word-inner');
    if (!inners.length) return;
    gs.set(inners, { yPercent: 100 });
    gs.to(inners, { yPercent: 0, duration: 0.9, stagger: 0.08, ease: 'power3.out' });
  }

  function playStep2Headings(scope, onComplete) {
    if (!window.gsap || prefersReducedMotion()) {
      if (onComplete) onComplete();
      return;
    }
    var gs = window.gsap;
    var nodes = scope.querySelectorAll('[data-step="2"] [data-quiz-heading-reveal]');
    if (!nodes.length) {
      if (onComplete) onComplete();
      return;
    }
    var i = 0;
    var tl = gs.timeline({ onComplete: onComplete });
    nodes.forEach(function (el) {
      splitHeadingIntoWordSpans(el);
      var inners = el.querySelectorAll('.quiz-signs__word-inner');
      if (!inners.length) return;
      gs.set(inners, { yPercent: 100 });
      var startAt = i === 0 ? 0 : '+=0.2';
      i += 1;
      tl.to(inners, { yPercent: 0, duration: 0.85, stagger: 0.07, ease: 'power3.out' }, startAt);
    });
  }

  /* Scroll-driven fade + rise (for non-heading copy / blocks) */
  function registerSubtleScrollReveals(root) {
    if (!root || !window.gsap || prefersReducedMotion()) return;
    var ST = window.ScrollTrigger;
    if (!ST) return;
    var gs = window.gsap;
    try { gs.registerPlugin(ST); } catch (e) { return; }

    var nodes = root.querySelectorAll('[data-quiz-scroll-reveal]:not([data-quiz-st-inited])');
    if (!nodes.length) return;
    nodes.forEach(function (el) {
      el.setAttribute('data-quiz-st-inited', 'true');
      gs.set(el, { autoAlpha: 0, y: 22, force3D: true });
      gs.to(el, {
        autoAlpha: 1,
        y: 0,
        duration: 1.15,
        ease: 'power2.out',
        overwrite: 'auto',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          once: true,
          toggleActions: 'play none none none'
        }
      });
    });
    ST.refresh();
  }

  function destroyRitualStaggerEntrance(section) {
    if (!section) return;
    if (section._quizRitualStaggerTween) {
      try { section._quizRitualStaggerTween.kill(); } catch (e) {}
      section._quizRitualStaggerTween = null;
    }
  }

  function initRitualStaggerEntrance(section) {
    if (!section || !window.gsap || !window.ScrollTrigger || prefersReducedMotion()) return;
    var gs = window.gsap;
    try { gs.registerPlugin(window.ScrollTrigger); } catch (e) { return; }

    destroyRitualStaggerEntrance(section);

    var ritualBlock = section.querySelector('[data-ritual-section]');
    var items = section.querySelectorAll('.quiz-signs__ritual-item');
    if (!ritualBlock || !items.length) return;

    var tw = gs.from(items, {
      y: 30,
      opacity: 0,
      duration: 0.8,
      stagger: 0.2,
      ease: 'power2.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: ritualBlock,
        start: 'top 80%',
        once: true,
        toggleActions: 'play none none none'
      }
    });
    section._quizRitualStaggerTween = tw;
  }

  function destroyInsightStaggerEntrance(section) {
    if (!section) return;
    if (section._quizInsightStaggerTween) {
      try { section._quizInsightStaggerTween.kill(); } catch (e) {}
      section._quizInsightStaggerTween = null;
    }
  }

  function initInsightStaggerEntrance(section) {
    if (!section || !window.gsap || !window.ScrollTrigger || prefersReducedMotion()) return;
    var gs = window.gsap;
    try { gs.registerPlugin(window.ScrollTrigger); } catch (e) { return; }

    destroyInsightStaggerEntrance(section);

    var insightBlock = section.querySelector('[data-insight-section]');
    var items = section.querySelectorAll('.quiz-signs__insight-item');
    if (!insightBlock || !items.length) return;

    var slideX = 56;
    var tw = gs.from(items, {
      x: function (i) {
        return (i % 2 === 0 ? 1 : -1) * slideX;
      },
      opacity: 0,
      duration: 0.88,
      stagger: 0.22,
      ease: 'power2.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: insightBlock,
        start: 'top 80%',
        once: true,
        toggleActions: 'play none none none'
      }
    });
    section._quizInsightStaggerTween = tw;
  }

  /** Re-measure and force stagger play if the trigger is in view but the tween never started (e.g. after smooth scroll). */
  function nudgeStaggerTweensAfterLayout(section) {
    if (!section) return;
    if (!window.ScrollTrigger) return;
    function go(tw) {
      if (!tw || !tw.scrollTrigger) return;
      tw.scrollTrigger.refresh();
      if (tw.scrollTrigger.isActive && tw.totalProgress() < 0.01) {
        tw.restart(0, false);
      }
    }
    go(section._quizRitualStaggerTween);
    go(section._quizInsightStaggerTween);
  }

  function hideQuizBundleNotice(section) {
    var n = section.querySelector('[data-quiz-bundle-notice]');
    if (n) n.hidden = true;
  }

  function showQuizBundleNotice(section) {
    var n = section.querySelector('[data-quiz-bundle-notice]');
    if (!n) return;
    n.hidden = false;
    try {
      n.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) {}
  }

  function getShopifyRouteRoot() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  /**
   * Apply a discount code to the Ajax cart (Shopify Cart API — POST cart/update.js).
   * Falls back to GET /discount/CODE if the update request fails (older environments).
   */
  function applyShopifyDiscountCode(code) {
    if (!code || !String(code).trim()) return Promise.resolve();
    var c = String(code).trim();
    var root = getShopifyRouteRoot();
    function discountUrlFallback() {
      return fetch(root + 'discount/' + encodeURIComponent(c) + '?redirect=/cart', {
        method: 'GET',
        credentials: 'same-origin',
        mode: 'same-origin',
        redirect: 'follow'
      }).then(function () {}, function () {});
    }
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: c })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;
          return body;
        });
      })
      .catch(function () {
        return discountUrlFallback();
      });
  }

  function quizBundleVariantIdsFromGrid(section) {
    var grid = section.querySelector('[data-recommended-products]');
    if (!grid) return null;
    var cards = grid.querySelectorAll('.quiz-product-card[data-bundle-role]');
    if (cards.length < 3) return null;
    var ids = [];
    for (var i = 0; i < cards.length; i++) {
      var btnEl = cards[i].querySelector('[data-variant-id]');
      if (!btnEl) return null;
      var vid = parseInt(btnEl.getAttribute('data-variant-id'), 10);
      if (!vid) return null;
      ids.push(vid);
    }
    return ids;
  }

  function cartHasAllVariantIds(cart, variantIds) {
    if (!cart || !cart.items || !variantIds) return false;
    var counts = {};
    var i, line, vid;
    for (i = 0; i < cart.items.length; i++) {
      line = cart.items[i];
      vid = line.variant_id;
      counts[vid] = (counts[vid] || 0) + line.quantity;
    }
    for (i = 0; i < variantIds.length; i++) {
      if (!counts[variantIds[i]]) return false;
    }
    return true;
  }

  function quizStellarBundleComplete(section, cart) {
    var ids = quizBundleVariantIdsFromGrid(section);
    if (!ids) return false;
    return cartHasAllVariantIds(cart, ids);
  }

  /* ---------- DOM Logic ---------- */
  function initSection(section) {
    var form = section.querySelector('[data-quiz-form]'),
        placeInput = section.querySelector('[data-place-input]'),
        placeSugg = section.querySelector('[data-place-suggestions]'),
        submitBtn = section.querySelector('[data-quiz-submit]'),
        resultsCards = section.querySelector('[data-results-cards]'),
        copyEl = section.querySelector('[data-quiz-signs-copy]'),
        signCopy = JSON.parse(copyEl.textContent || '{}'),
        bundleCfg = section.querySelector('[data-quiz-bundle-config]'),
        bundleDiscountCode = bundleCfg && bundleCfg.getAttribute('data-discount-code')
          ? bundleCfg.getAttribute('data-discount-code').trim()
          : '',
        selectedPlace = null;

    // Autocomplete
    placeInput.addEventListener('input', function () {
      // user is editing the free-typed value — any previously-picked
      // suggestion is now stale and must not be reused for lat/lng.
      if (selectedPlace && placeInput.value !== selectedPlace.label) {
        selectedPlace = null;
      }
    });

    placeInput.addEventListener('input', debounce(function () {
      var q = placeInput.value.trim();
      if (q.length < 3) { placeSugg.hidden = true; return; }
      nominatimSearch(q).then(function (results) {
        placeSugg.innerHTML = '';
        if (!results || !results.length) {
          var empty = document.createElement('li');
          empty.className = 'quiz-signs__suggestion--empty';
          empty.textContent = 'No matches — try a bigger city nearby.';
          placeSugg.appendChild(empty);
          placeSugg.hidden = false;
          return;
        }
        results.slice(0, 6).forEach(function (r) {
          var li = document.createElement('li');
          li.className = 'quiz-signs__suggestion';
          li.setAttribute('role', 'option');
          li.textContent = r.display_name;
          li.addEventListener('mousedown', function (e) {
            // mousedown (not click) so it fires before the input's blur.
            e.preventDefault();
            selectedPlace = { label: r.display_name, lat: parseFloat(r.lat), lng: parseFloat(r.lon) };
            placeInput.value = r.display_name;
            placeSugg.hidden = true;
          });
          placeSugg.appendChild(li);
        });
        placeSugg.hidden = false;
      });
    }, 300));

    // Close the dropdown when clicking anywhere outside it.
    document.addEventListener('click', function (e) {
      if (!placeSugg.contains(e.target) && e.target !== placeInput) {
        placeSugg.hidden = true;
      }
    });

    placeInput.addEventListener('focus', function () {
      if (placeSugg.children.length) placeSugg.hidden = false;
    });

    // Small placement icons (sun / moon / rising) rendered as inline SVG so
    // they stay crisp and follow currentColor.
    var PLACEMENT_ICONS = {
      sun: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>',
      moon: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/></svg>',
      rising: '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 18l8-12 8 12"/></svg>'
    };

    /**
     * From one sign’s collection: pick candle (Sun), soap (Moon), or incense (Rising)
     * by Shopify product type + title keywords — no manual per-product assignment.
     */
    function pickProductByRole(products, role) {
      if (!products || !products.length) return null;
      var L = function (s) { return String(s || '').toLowerCase(); };
      var i, p, typ, tit;
      function isCandle(q) {
        typ = L(q.type); tit = L(q.title);
        if (typ.indexOf('candle') !== -1 || tit.indexOf('candle') !== -1) return true;
        return false;
      }
      function isSoap(q) {
        typ = L(q.type); tit = L(q.title);
        if (typ.indexOf('soap') !== -1 || tit.indexOf('soap') !== -1) return true;
        if (tit.indexOf('bar') !== -1 && tit.indexOf('candle') === -1 && tit.indexOf('scent stick') === -1) return true;
        return false;
      }
      function isIncense(q) {
        typ = L(q.type); tit = L(q.title);
        if (typ.indexOf('incense') !== -1 || tit.indexOf('incense') !== -1) return true;
        if (tit.indexOf('scent stick') !== -1 || tit.indexOf('scent sticks') !== -1) return true;
        if (tit.indexOf('stick') !== -1 && tit.indexOf('candle') === -1) return true;
        return false;
      }
      var test = role === 'candle' ? isCandle : role === 'soap' ? isSoap : isIncense;
      for (i = 0; i < products.length; i++) {
        p = products[i];
        if (test(p)) return p;
      }
      return products[0];
    }

    function pickSignProduct(signData, role) {
      var sc = signCopy[signData.sign.key] || {};
      return pickProductByRole(sc.products, role);
    }

    function buildCard(label, signData, mod) {
      var el = document.createElement('div');
      el.className = 'quiz-signs__card quiz-signs__card--' + mod;
      el.setAttribute('data-quiz-scroll-reveal', '');
      var s = signData.sign, copy = signCopy[s.key] || {};
      var icon = PLACEMENT_ICONS[mod] || '';
      el.innerHTML =
        '<div class="quiz-signs__card-top">' +
          '<span class="quiz-signs__card-icon">' + icon + '</span>' +
          '<span class="quiz-signs__card-kind">' + label.replace(/\s*SIGN$/i, '') + '</span>' +
        '</div>' +
        '<h3 class="quiz-signs__card-sign">' + (copy.name || s.name) + '</h3>' +
        (copy.element ? '<span class="quiz-signs__element-tag">' + copy.element.toUpperCase() + '</span>' : '');
      return el;
    }

    function renderResults(sun, moon, rising) {
      section.querySelector('[data-step="loading"]').hidden = true;
      section.querySelector('[data-step="2"]').hidden = false;

      hideQuizBundleNotice(section);

      // 1. Cards
      resultsCards.innerHTML = '';
      resultsCards.appendChild(buildCard('SUN SIGN', sun, 'sun'));
      resultsCards.appendChild(buildCard('MOON SIGN', moon, 'moon'));
      if (rising) resultsCards.appendChild(buildCard('RISING SIGN', rising, 'rising'));

      // 2. Personality insight — same staggered text reveal as ritual (no pin: avoids blank layout bugs)
      destroyInsightStaggerEntrance(section);
      var sunC  = signCopy[sun.sign.key]  || {};
      var moonC = signCopy[moon.sign.key] || {};
      var risC  = rising ? (signCopy[rising.sign.key] || {}) : null;
      var parts = [];
      var labels = ['Sun', 'Moon', 'Rising'];
      if (sunC.blurb)  parts.push({ label: 'Core — ' + labels[0], html: 'At your core, you’re a <strong>' + (sunC.name  || sun.sign.name)  + '</strong>. — ' + sunC.blurb });
      if (moonC.blurb) parts.push({ label: 'Inner — ' + labels[1], html: 'Emotionally, you’re a <strong>' + (moonC.name || moon.sign.name) + '</strong>.— ' + moonC.blurb });
      if (risC && risC.blurb) parts.push({ label: 'Persona — ' + labels[2], html: 'To everyone else, you’re a <strong>' + (risC.name || rising.sign.name) + '</strong>. — ' + risC.blurb });
      var insightList = section.querySelector('[data-insight-list]');
      if (insightList) {
        if (parts.length === 0) {
          insightList.innerHTML = '';
        } else {
          var iid = (section.id || 'quiz-insight').replace(/[^a-zA-Z0-9-_]/g, '-');
          insightList.innerHTML = parts.map(function (pt, i) {
            return (
              '<div class="quiz-signs__insight-item insight-item" role="group" aria-labelledby="' + iid + '-insight-' + i + '">' +
                '<p class="quiz-signs__insight-kicker" id="' + iid + '-insight-' + i + '">' + pt.label + '</p>' +
                '<p class="quiz-signs__insight-text">' + pt.html + '</p>' +
              '</div>'
            );
          }).join('');
        }
      }

      // 3. Products: Sun → candle, Moon → soap, Rising → incense (from each sign’s collection, matched by type/title)
      var grid = section.querySelector('[data-recommended-products]');
      if (grid) {
        grid.innerHTML = '';
        var recs = [
          { sign: sun,  typeKey: 'candle',  label: 'CANDLE' },
          { sign: moon, typeKey: 'soap',     label: 'SOAP' }
        ];
        if (rising) recs.push({ sign: rising, typeKey: 'incense', label: 'INCENSE' });
        recs.forEach(function (row) {
          var p = pickSignProduct(row.sign, row.typeKey);
          if (!p) return;
          var sc = signCopy[row.sign.sign.key] || {};
          var scent = sc.scent || '';
          var forTag = row.sign === sun ? 'SUN' : row.sign === moon ? 'MOON' : 'RISING';
          grid.innerHTML +=
            '<article class="quiz-product-card" data-quiz-scroll-reveal data-bundle-role="' + row.typeKey + '">' +
              '<div class="quiz-product-card__media">' +
                '<img src="' + p.image + '" alt="' + p.title + '">' +
              '</div>' +
              '<div class="quiz-product-card__body">' +
                '<p class="quiz-product-label">' + row.label + ' · FOR YOUR ' + forTag + '</p>' +
                '<div class="quiz-product-card__head">' +
                  '<h4 class="quiz-product-card__title">' + p.title + '</h4>' +
                  '<p class="quiz-product-card__price">' + p.price + '</p>' +
                '</div>' +
                (scent ? '<p class="quiz-product-card__scent">' + scent + '</p>' : '') +
              '</div>' +
              '<button type="button" class="btn btn--atc-ajax" data-variant-id="' + p.id + '">Add to basket</button>' +
            '</article>';
        });
      }

      // 4. Ritual — staggered fade + slide when the section scrolls in 
      destroyRitualStaggerEntrance(section);
      var ritualList = section.querySelector('[data-ritual-list]');
      if (ritualList) {
        var rrid = (section.id || 'quiz-ritual').replace(/[^a-zA-Z0-9-_]/g, '-');
        var risingIncense = rising
          ? 'Your Rising is ' + rising.sign.name + ' . Burn the incense before people arrive. First impressions matter. Unfortunately.'
          : 'No birth time, no Rising sign. Burn the incense anyway.';

        ritualList.innerHTML =
          '<div class="quiz-signs__ritual-item ritual-item" role="group" aria-labelledby="' + rrid + '-ritual-moon">' +
            '<p class="quiz-signs__ritual-kicker" id="' + rrid + '-ritual-moon">Moon &amp; soap</p>' +
            '<p class="quiz-signs__ritual-text">Your Moon is ' + moon.sign.name + ' . Start the day by washing off whatever pissed you off yesterday. Consider it a clean slate.</p>' +
          '</div>' +
          '<div class="quiz-signs__ritual-item ritual-item" role="group" aria-labelledby="' + rrid + '-ritual-sun">' +
            '<p class="quiz-signs__ritual-kicker" id="' + rrid + '-ritual-sun"> Sun &amp; candle</p>' +
            '<p class="quiz-signs__ritual-text">Your Sun is ' + sun.sign.name + '. Light the candle, shut the door and disappear into your own world for a bit. You were going to anyway.</p>' +
          '</div>' +
          '<div class="quiz-signs__ritual-item ritual-item" role="group" aria-labelledby="' + rrid + '-ritual-rising">' +
            '<p class="quiz-signs__ritual-kicker" id="' + rrid + '-ritual-rising">Rising &amp; incense</p>' +
            '<p class="quiz-signs__ritual-text">' + risingIncense + '</p>' +
          '</div>';
      }

      registerSubtleScrollReveals(section.querySelector('[data-step="2"]'));

      requestAnimationFrame(function () {
        initInsightStaggerEntrance(section);
        initRitualStaggerEntrance(section);
        var step2 = section.querySelector('[data-step="2"]');
        if (step2) step2.scrollIntoView({ behavior: 'smooth' });
        playStep2Headings(section);
        var onLayoutSettled = function () {
          if (window.ScrollTrigger) window.ScrollTrigger.refresh(true);
          nudgeStaggerTweensAfterLayout(section);
        };
        requestAnimationFrame(function () {
          onLayoutSettled();
        });
        setTimeout(onLayoutSettled, 400);
        setTimeout(onLayoutSettled, 900);
        if (window.addEventListener) {
          try {
            window.addEventListener('scrollend', onLayoutSettled, { once: true, passive: true });
          } catch (e) {
            window.addEventListener('scrollend', onLayoutSettled, false);
          }
        }
      });
    }

    submitBtn.onclick = function () {
      var dob = form.querySelector('[name="dob"]').value, 
          time = form.querySelector('[name="time"]').value,
          place = placeInput.value.trim();
      if (!dob || !place) return;

      section.querySelector('[data-step="1"]').hidden = true;
      section.querySelector('[data-step="loading"]').hidden = false;

      var pP = selectedPlace ? Promise.resolve(selectedPlace) : nominatimSearch(place).then(function(res) { return { lat: res[0].lat, lng: res[0].lon }; });
      
      pP.then(function (pO) {
        return fetchTimezone(pO.lat, pO.lng).then(function (tz) {
          var d = dob.split('-'),
              hh = time ? parseInt(time.split(':')[0], 10) : 12,
              mm = time ? parseInt(time.split(':')[1], 10) : 0,
              utc = zonedToUtc(+d[0], +d[1], +d[2], hh, mm, tz || 'UTC');
          var c = sunMoonLongitudes(utc), ris = null;
          if (time) ris = signFromLongitude(computeAscendantDeg(localSiderealTimeDeg(c.time, pO.lng), meanObliquityDeg(c.time), pO.lat));
          setTimeout(function() { renderResults(signFromLongitude(c.sun), signFromLongitude(c.moon), ris); }, 800);
        });
      });
    };

    // --- KLAVIYO ---
    var kForm = section.querySelector('#quiz-klaviyo-form');
    if (kForm) {
      kForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = section.querySelector('#klaviyo-submit-btn');
        btn.innerText = 'SENDING...';
        btn.disabled = true;
        setTimeout(function() {
          kForm.style.opacity = '0.5';
          section.querySelector('#klaviyo-success-msg').hidden = false;
          btn.innerText = 'SENT!';
        }, 1000);
      });
    }

    // --- START OVER ---
    var restartBtn = section.querySelector('[data-quiz-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        destroyRitualStaggerEntrance(section);
        destroyInsightStaggerEntrance(section);

        var step2el = section.querySelector('[data-step="2"]');
        if (step2el && window.ScrollTrigger) {
          window.ScrollTrigger.getAll().forEach(function (st) {
            try {
              if (st.trigger && step2el.contains(st.trigger)) st.kill();
            } catch (err) {}
          });
        }
        if (step2el && window.gsap) {
          step2el.querySelectorAll('[data-quiz-st-inited]').forEach(function (el) {
            el.removeAttribute('data-quiz-st-inited');
            window.gsap.killTweensOf(el);
            window.gsap.set(el, { clearProps: 'all' });
          });
        }

        if (resultsCards) resultsCards.innerHTML = '';
        var insightList = section.querySelector('[data-insight-list]');
        if (insightList) insightList.innerHTML = '';
        var grid = section.querySelector('[data-recommended-products]');
        if (grid) grid.innerHTML = '';
        var ritualList = section.querySelector('[data-ritual-list]');
        if (ritualList) ritualList.innerHTML = '';
        var resultsFor = section.querySelector('[data-results-for]');
        if (resultsFor) resultsFor.textContent = '';

        hideQuizBundleNotice(section);

        section.querySelector('[data-step="loading"]').hidden = true;
        if (step2el) step2el.hidden = true;
        var step1el = section.querySelector('[data-step="1"]');
        if (step1el) {
          step1el.hidden = false;
          step1el.scrollIntoView({ behavior: 'smooth' });
        }

        if (form) form.reset();
        selectedPlace = null;
        if (placeSugg) {
          placeSugg.hidden = true;
          placeSugg.innerHTML = '';
        }
        var formErr = section.querySelector('[data-form-error]');
        if (formErr) {
          formErr.hidden = true;
          formErr.textContent = '';
        }

        if (kForm) {
          kForm.style.opacity = '';
          var kbtn = section.querySelector('#klaviyo-submit-btn');
          if (kbtn) {
            kbtn.disabled = false;
            kbtn.innerText = 'SEND';
          }
          var kmsg = section.querySelector('#klaviyo-success-msg');
          if (kmsg) kmsg.hidden = true;
        }

        if (window.ScrollTrigger) window.ScrollTrigger.refresh(true);
      });
    }

    // --- CART ---
    // The theme instantiates a CartDrawer on window.cart (see theme.dev.js,
    // `window.cart = new CartDrawer()` inside the header section). Its
    // getCart() method re-fetches the cart, rebuilds the drawer DOM, updates
    // the header cart badge, and opens the drawer. We call it after a
    // successful /cart/add.js so the storefront stays in sync without a
    // page reload.
    section.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.btn--atc-ajax');
      if (!btn || !section.contains(btn)) return;

      var vId = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vId) return;

      var originalLabel = btn.dataset.originalLabel || btn.innerText;
      btn.dataset.originalLabel = originalLabel;
      btn.disabled = true;
      btn.innerText = 'Adding…';

      function finishBtn() {
        setTimeout(function () {
          btn.disabled = false;
          btn.innerText = btn.dataset.originalLabel;
        }, 1800);
      }

      function refreshThemeCart() {
        if (window.cart && typeof window.cart.getCart === 'function') {
          try { window.cart.getCart(); } catch (err) { /* fall through */ }
        } else {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
            })
            .catch(function () {});
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: [{ id: vId, quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        btn.innerText = 'Added';

        var stellar = quizStellarBundleComplete(section, cart);
        var pDiscount = Promise.resolve();
        if (stellar) {
          showQuizBundleNotice(section);
          if (bundleDiscountCode) pDiscount = applyShopifyDiscountCode(bundleDiscountCode);
        }

        return pDiscount.then(function () {
          refreshThemeCart();
          finishBtn();
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.innerText = (err && err.description) ? 'Unavailable' : 'Try again';
        setTimeout(function () { btn.innerText = btn.dataset.originalLabel; }, 2200);
      });
    });

    registerSubtleScrollReveals(section.querySelector('[data-step="1"]'));
    var step1Title = section.querySelector('[data-step="1"] [data-quiz-heading-reveal]');
    playStep1Heading(step1Title);
  }

  var GsapBootAttempts = 0;
  var GsapBootMax = 80; /* ~4s if GSAP CDN is slow; quiz still init without it */

  function boot() {
    if (!window.Astronomy) return setTimeout(boot, 50);
    if (!window.gsap) {
      GsapBootAttempts += 1;
      if (GsapBootAttempts < GsapBootMax) return setTimeout(boot, 50);
    }
    document.querySelectorAll('[data-section-type="quiz-signs"]').forEach(initSection);
  }
  boot();
})();